export const sideNavItems = [
  {
    id: 'player',
    name: 'Player',
    icon: 'PlayerFootball',
    position: 'top',
    sections: ['player'],
    links: [
      {
        name: 'Overview',
        href: '/player/overview/:leagues/:seasons/:teams/:players',
        id: 'player/overview',
      },
      {
        name: 'Pass Placement',
        href: '/player/placement/:leagues/:seasons/:teams/:players',
        id: 'player/placement',
      },
      {
        name: 'Passing Chart',
        href: '/player/passing/:leagues/:seasons/:teams/:players',
        id: 'player/passing',
      },
      {
        name: 'Snap Alignment',
        href: '/player/snap/:leagues/:seasons/:teams/:players',
        id: 'player/snap',
      },
      {
        name: 'Radar',
        href: '/player/radar/:leagues/:seasons/:teams/:players',
        id: 'player/radar',
      },
      {
        name: 'Routes Run',
        href: '/player/route/:leagues/:seasons/:teams/:players',
        id: 'player/route',
      },
      {
        name: 'Comparison',
        href: '/player/comparison/:leagues/:seasons/:teams/:players',
        id: 'player/comparison',
      },
    ],
  },
  {
    id: 'team',
    name: 'Team',
    icon: 'TeamFootball',
    position: 'top',
    sections: ['team'],
    links: [
      {
        name: 'Overview',
        href: '/team/overview/:leagues/:seasons/:teams',
        id: 'team/overview',
      },
      {
        name: 'Box Score',
        href: '/team/box/:leagues/:seasons/:teams',
        id: 'team/box',
      },
      {
        name: 'Passing Chart',
        href: '/team/passing/:leagues/:seasons/:teams',
        id: 'team/passing',
      },
      {
        name: 'Line Pressures',
        href: '/team/linePressure/:leagues/:seasons/:teams',
        id: 'team/linePressure',
      },
      {
        name: 'Run Tendencies',
        href: '/team/runTendencies/:leagues/:seasons/:teams',
        id: 'team/runTendencies',
      },
      {
        name: 'Tackling Map',
        href: '/team/tackles/:leagues/:seasons/:teams',
        id: 'team/tackles',
      },
      {
        name: 'Havoc Events',
        href: '/team/havocSummary/:leagues/:seasons/:teams',
        id: 'team/havocSummary',
      },
      {
        name: 'Depth Chart',
        href: '/team/depth/:leagues/:seasons/:teams',
        id: 'team/depth',
      },
      {
        name: 'Formation Summary',
        href: '/team/summary/:leagues/:seasons/:teams',
        id: 'team/summary',
      },
      {
        name: 'Defensive Scheme',
        href: '/team/defensiveScheme/:leagues/:seasons/:teams',
        id: 'team/defensiveScheme',
      },
      {
        name: 'Formation Detail',
        href: '/team/detail/:leagues/:seasons/:teams',
        id: 'team/detail',
        userGroup: 'statsbomb',
        wip: true,
      },
      {
        name: 'Player +/-',
        href: '/team/impact/:leagues/:seasons/:teams',
        id: 'team/impact',
        userGroup: 'statsbomb',
        wip: true,
      },
      {
        name: 'Radar',
        href: '/team/radar/:leagues/:seasons/:teams',
        id: 'team/radar',
      },
      {
        name: 'Schedule',
        href: '/team/schedule/:leagues/:seasons/:teams',
        id: 'team/schedule',
      },
    ],
  },
  {
    id: 'playfinder',
    name: 'Play Finder',
    icon: 'IqTactics',
    component: 'a',
    componentProps: { href: '/playfinder/wizard' },
  },
  {
    id: 'league',
    name: 'League',
    icon: 'League',
    position: 'top',
    sections: ['league'],
    links: [
      {
        name: 'Player Stats',
        href: '/league/stats/players/:leagues/:seasons',
        id: 'league/stats/players',
      },
      {
        name: 'Team Stats',
        href: '/league/stats/teams/:leagues/:seasons',
        id: 'league/stats/teams',
      },
    ],
  },
  {
    id: 'game',
    name: 'Game',
    icon: 'MatchFootball',
    position: 'top',
    sections: ['game'],
    links: [
      {
        name: 'Overview',
        href: '/game/overview/:leagues/:seasons/:teams/:games',
        id: 'game/overview',
      },
      {
        name: 'Play Animation',
        href: '/game/animation/:leagues/:seasons/:teams/:games/:drives/:plays',
        id: 'game/animation',
      },
      {
        name: 'Snap Formations',
        href: '/game/formations/:leagues/:seasons/:teams/:games/:drives',
        id: 'game/formations',
      },
      {
        name: 'Play Event Tiles',
        href: '/game/event/:leagues/:seasons/:teams/:games/:drives/:plays',
        id: 'game/event',
      },
      {
        name: 'Play By Play Feed',
        href: '/game/byplay/:leagues/:seasons/:teams/:games',
        id: 'game/byplay',
      },
    ],
  },
  {
    id: 'scout',
    name: 'Scout',
    icon: 'IqScout',
    component: 'a',
    componentProps: { href: '/scout/players/:leagues/:seasons' },
  },
];

export const sideNavFooterItems = [
  {
    id: 'playlists',
    name: 'My Playlists',
    icon: 'Playlist',
    component: 'a',
    componentProps: { href: '/playlists' },
  },
  {
    id: 'admin',
    name: 'Admin',
    icon: 'Profile',
    position: 'bottom',
    sections: ['admin'],
    links: [
      {
        name: 'Admin',
        href: '/admin',
        id: 'admin',
      },
      {
        name: 'API / Data dictionary',
        href: '/data-access',
        id: 'data-access',
      },
      {
        name: 'Logout',
        href: '/',
      },
    ],
  },
  {
    id: 'assist',
    name: 'Support',
    icon: 'Support',
    position: 'bottom',
    sections: ['assist'],
    links: [
      {
        name: 'Support',
        href: 'https://support.hudl.com/s/topic/0TOVY000000BO8h4AG/hudl-iq?language=en_US',
        id: 'support',
      },
      {
        name: 'Release Notes',
        href: 'https://www.hudl.com/releases/hudl-iq',
        id: 'release-notes',
      },
    ],
  },
];
export const isSectionSelected = (sectionPath, section) => {
  if (section?.sections) {
    return section.sections.some((path) => path === sectionPath.split('/')[0]);
  }
  return section.id === sectionPath.split('/')[0];
};

export const isPageSelected = (location = '', pageId) =>
  (pageId === 'admin' && !location) || location.includes(pageId);
